import { render, staticRenderFns } from "./monitor_block.vue?vue&type=template&id=36759212&scoped=true&"
import script from "./monitor_block.vue?vue&type=script&lang=js&"
export * from "./monitor_block.vue?vue&type=script&lang=js&"
import style0 from "./monitor_block.vue?vue&type=style&index=0&id=36759212&lang=scss&scoped=true&"
import style1 from "./monitor_block.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36759212",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('36759212', component.options)
    } else {
      api.reload('36759212', component.options)
    }
    module.hot.accept("./monitor_block.vue?vue&type=template&id=36759212&scoped=true&", function () {
      api.rerender('36759212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/monitor/monitor_block.vue"
export default component.exports